<template>
  <v-col 
    :cols="field.cols ? field.cols : '4'"
    class="ma-0 px-6 py-0">
    <v-tooltip bottom nudge-top="25px">
      <span>{{ field.tooltip || field.label }}</span>
      <template v-slot:activator="{ on }">
        <v-col v-on="field.type === 'section' ? null : on" class="ma-0 pa-0">
          <v-menu 
            v-if="field.type === 'date'" 
            :close-on-content-click="true" 
            transition="scale-transition" 
            offset-y
            nudge-left="25" 
            nudge-top="25" 
            max-width="290px" 
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field 
                v-on="on" 
                :label="fieldLabel" 
                v-model="payload[`${field.value}`]"
                prepend-inner-icon="mdi-calendar" 
                outlined background-color="#fff" 
                readonly 
                dense>
              </v-text-field>
            </template>
            <v-date-picker 
              v-model="payload[`${field.value}`]" 
              :allowed-dates="allowedDates" 
              :min="minDate" 
              no-title>
            </v-date-picker>
          </v-menu>
          <v-checkbox 
            v-else-if="field.type === 'boolean'" 
            :label="fieldLabel" 
            v-model="payload[`${field.value}`]"
            dense>
          </v-checkbox>
          <v-autocomplete v-else-if="field.type === 'select' && field.value === 'hosting_file_type_id'"
            :disabled="['null', null].includes(payload.hosting_file_participation_id)"
            :label="fieldLabel" 
            v-model="payload[`${field.value}`]"
            outlined
            :items="listsByFieldValue[field.value] || []"
            :item-text="'name'"
            :item-value="'id'"
            clearable 
          dense>
          </v-autocomplete>
          <v-autocomplete v-else-if="field.type === 'select' && field.value === 'hosting_file_program_id'"
            :disabled="payload.hosting_file_participation_id !== 'null'"
            :label="fieldLabel" 
            v-model="payload[`${field.value}`]"
            outlined
            :items="listsByFieldValue[field.value] || []"
            :item-text="'name'"
            :item-value="'id'"
            clearable 
          dense>
          </v-autocomplete>
          <v-autocomplete 
            v-else-if="field.type === 'select'" 
              :disabled="!payload['start_date']"
              :label="fieldLabel" 
              v-model="payload[`${field.value}`]"
              outlined 
              :items="listsByFieldValue[field.value] || []"
              :item-text="['ad_group_id', 'owner_id', 'division_id'].includes(field.value) ? 'name' : 'name'"
              :item-value="['ad_group_id', 'owner_id', 'division_id'].includes(field.value) ? 'id' : 'id'"
              clearable 
              dense>
          </v-autocomplete>
          <v-autocomplete
            v-else-if="field.type === 'array'" 
              :label="fieldLabel" 
              multiple 
              clearable
              v-model="payload[`${field.value}`]" 
              outlined 
              :items="listsByFieldValue[field.value] || []" 
              item-text="name" 
              item-value="id" 
              dense>
          </v-autocomplete>
          <v-container class="mx-0 px-0 pt-2 pb-2" v-else-if="field.type === 'section'"
          >
            <v-col class="mx-0 pa-0">
              <div class="font-weight-bold" align="start">
                {{ fieldLabel }}
              </div>
              <v-row>
                <v-col 
                  class="mx-0 px-3 pt-4 pb-0"
                  :cols="subfield.cols ? subfield.cols : '2'" v-for="subfield in field.sectionFields"
                  :key="subfield.value">
                  <v-tooltip bottom nudge-top="25px">
                    <span>{{ subfield.tooltip || subfield.label }}</span>
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-text-field
                          v-if="(subfield.type === 'string' || subfield.type === 'number') && !['equipment'].includes(subfield.value)"
                          :type="subfield.type"
                          :label="subfield.label + (subfield.required ? '*' : '')"
                          v-model="payload[`${field.value}`][`${subfield.value}`]"
                          :disabled="(field.value === 'rebate' && payload.rebate.paying_option_id != checkId) || (field.value === 'pos_contact' && ![scanOnlyId, scanAndBillbackId].includes(payload.billing_program_type_id))"
                          outlined
                          hide-spin-buttons
                          @change="validate($event, field.value, subfield.value)"
                          background-color="#fff"
                          dense>
                        </v-text-field>
                        <v-textarea
                          v-if="subfield.value.includes('equipment')"
                          dense
                          rows="4"
                          v-model="payload[`${field.value}`][`${subfield.value}`]"
                          :label="subfield.label + (subfield.required ? '*' : '')"
                          :disabled="![scanOnlyId, scanAndBillbackId].includes(payload.billing_program_type_id)"
                          outlined>
                        </v-textarea>
                        <v-autocomplete v-if="subfield.value === 'pos_brand_id'"
                          :label="subfield.label + (subfield.required ? '*' : '')"
                          v-model="payload[`${field.value}`][`${subfield.value}`]"
                          :disabled="![scanOnlyId, scanAndBillbackId].includes(payload.billing_program_type_id)"
                          :items="brandList"
                          outlined
                          item-text="name"
                          item-value="id"
                          clearable
                          dense>
                        </v-autocomplete>
                        <v-autocomplete v-if="subfield.type === 'select' && subfield.value != 'pos_brand_id'"
                          :label="subfield.label + (subfield.required ? '*' : '')"
                          v-model="payload[`${field.value}`][`${subfield.value}`]"
                          :items="subfield.value === 'paying_option_id' ? paymentTypes : (listsByFieldValue[subfield.value] || [])"
                          :disabled="(field.value === 'rebate' && subfield.value != 'paying_option_id' && payload.rebate.paying_option_id != checkId) || (field.value === 'pos_contact' && ![scanOnlyId, scanAndBillbackId].includes(payload.billing_program_type_id))"
                          :filter="subfield.value === 'state' ? getStateList : () => {}"
                          outlined
                          item-text="name"
                          item-value="id"
                          clearable
                          dense>
                        </v-autocomplete>
                      </div>
                    </template>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-container>
          <v-text-field
            v-else 
            :type="field.type"
            :prefix="field.value === 'weekly_sales' ? '$' : ''"
            :maxLength="field.value ==='store_number' ? 4 : 99"
            :label="fieldLabel"
            :error-messages="errorMessage"
            v-model="payload[`${field.value}`]"
            @change="validate($event, field.value)"
            outlined
            hide-spin-buttons
            background-color="#fff"
            dense>
          </v-text-field>
        </v-col>
      </template>
    </v-tooltip>
  </v-col>
</template>
<script>
import kvApi from "@/axios/key-values-endpoint.js"
import PhoneNumber from 'awesome-phonenumber'
import Party from '@/axios/party-endpoint.js'
import { displayAlert } from '@/mixins/alert'
import { subMonths, format } from 'date-fns'
import { partySearch } from '@/mixins/party-search'

export default {
  name: "StoreFormField",
  props: {
    field: Object, 
    currentPage: Number, 
    params: Object,
    paymentTypes: Array,
    activeStoreList: Array,
    checkId: String,
    scanOnlyId: String,
    scanAndBillbackId: String,
    errorMessage: String
  },
  data() {
    return {
      partyAttributes: [],
      partyAttributeGroups: {},
      partyAttributeValues: [],
      listsByFieldValue: {},
      brandList: [],
      allowedDates: val => new Date(val + "T00:00:00").getDay() === 0,
      minDate: format(subMonths(new Date(), 1), 'yyyy-MM-dd'),
      region: {
        code: 'US',
        name: 'United States of America'
      }
    }
  },
  mixins: [displayAlert, partySearch],
  watch: {
    "payload.start_date": {
      handler(val,oldVal) {
        if (val != oldVal) {
          if (['owner_id', 'ad_group_id', 'division_id'].includes(this.field.value)) {
            this.$set(this.listsByFieldValue, this.field.value, [])
            this.getValues(this.field.value)
          }
        } 
      }
    },
    payload: {
      handler() {
        this.$emit('update', this.payload)
      },
      deep: true
    }
  },
  computed: {
    payload() {
      return this.params;
    },
    fieldLabel() {
      return this.field.label + (this.field.required ? '*' : '')
    },
  },
  created() {
    if (this.field.type === "array" || (this.field.type === "select" && !['division_id', 'ad_group_id', 'owner_id'].includes(this.field.value))) {
      this.getValues(this.field.value)
    } else if ((this.field.sectionFields?.length > 1 && this.field.sectionFields?.map(s => s.type).includes('select'))) {
      this.field.sectionFields.forEach(f => {
        this.getValues(f.value)
      });
    }
  },
  methods: {
    validate(data, key, subkey) {

      const fieldValue = subkey || key
      if (!['phone_number', 'email_address', 'square_footage', 'weekly_sales', 'zip_code', 'store_number'].includes(fieldValue)) return;

      let validatedString = null;

      switch (fieldValue) {
        case 'phone_number': {
          const phone = new PhoneNumber(data, this.region.code).getNumber('international');
          validatedString = phone && data.length === 10 ? phone : null;
        }
          break;
        case 'email_address':
          validatedString = data.includes('@') ? data : null;
          break;
        case 'square_footage':
        case 'weekly_sales': {
          const convertedString = Number(data.replace(/,/g,""))
          validatedString = isNaN(convertedString) ? null : new Intl.NumberFormat('en-US').format(convertedString)
        }
          break;
        case 'zip_code':
          validatedString = data.length >= 5 ? data : null
          break;
        case 'store_number':
          validatedString = data
          this.$emit('updateErrorMessage', (this.activeStoreList.includes(data)) ? "An active store with this number already exists, please enter a different number" : null)
          break;
        default:
          validatedString = data
          break;
      }

      if (subkey != null) {
        this.payload[key][subkey] = validatedString;
      } else {
        this.payload[key] = validatedString;
      }
    },

    getStateList(item, queryText, itemText) {
      return itemText.toLocaleLowerCase().startsWith(queryText.toLocaleLowerCase())
    },

    async buildPartyList(partyType, fieldKey, offset = 0) {
      const keyMap = {
        'AD_GROUP': 'AD_GROUP',
        'DISTRIBUTION_CENTER': 'DC',
        'OWNER': "OWNER",
      }
      const payload = {
        "party_types": [partyType], 
        "attributes": {[`${keyMap[partyType]}_IS_ACTIVE`] : "True"}
      };

      if (this.params?.start_date) {
        payload['start_date'] = this.params?.start_date
      }
      let parties = []

      const res = await Party.searchParties(payload, offset);
      if (res?.data?.length > 0) {
            parties = res.data.map(p => this.formatParty(p));
      }
      if (!this.listsByFieldValue[fieldKey]) {
        this.$set(this.listsByFieldValue, fieldKey, [])
      }
      this.listsByFieldValue[fieldKey].push(...parties)
      if (parties.length === 250) { // Default Limit on Search Call is 250
        this.buildPartyList(partyType, fieldKey, offset+250);
      } else { // No More Parties to grab, sort the list
        this.listsByFieldValue[fieldKey].sort((a, b) => a.name.localeCompare(b.name, 'en', { 'sensitivity': 'base' }));
      }
    },

    async getValues(value) {
      const valueMap = {
        "ad_break_day_id": "DAY_OF_WEEK",
        "tpr_break_day_id": "DAY_OF_WEEK",
        "awg_center_deliver_day_ids": "DAY_OF_WEEK",
        "division_id": "DISTRIBUTION_CENTER",
        "billing_program_type_id": "BILLING_PROGRAM_TYPE",
        "group_manager_id": "GROUP_MANAGER",
        'pos_provider_id': "POS_SOFTWARE_PROVIDER",
        'pos_brand_id': "POS_EQUIPMENT_BRAND",
        "advertising_service_id": "ADVERTISING_SERVICE",
        "loyalty_digital_coupon_customer_id": "LOYALTY_COUPON_PROGRAM",
        "hosting_file_participation_id": "HOSTING_FILE_OPTION",
        "other_sponsored_programs": "SPONSORED_PROGRAMS",
        "store_format_id": "STORE_TYPE",
        "owner_id": "OWNER",
        "ad_group_id": "AD_GROUP",
        "paying_option_id": "PAYMENT_OPTION",
        'ad_length': "AD_LENGTH",
        "hosting_file_type_id": "HOSTING_FILE_TYPE",
        "hosting_file_program_id": "HOSTING_FILE_PROGRAM",
        "scan_collection_program_id": "SCAN_COLLECTION_PROGRAM"
      };

      const string = valueMap[value] || "";

      try {
        // Use provided prop list for paying_option_id to avoid overwriting
        if (value === 'paying_option_id') {
          return;
        }
        if (value === 'state') {
          const states = (await kvApi.keyValues.getList("STATE_PROVINCE_US", 100, 0)).data.sort((a, b) => a.name.localeCompare(b.name, 'en', { 'sensitivity': 'base' }));
          this.$set(this.listsByFieldValue, value, states)
        } else if (value === 'pos_provider_id') {
          const providers = (await kvApi.keyValues.getList("POS_SOFTWARE_PROVIDER", 100, 0)).data.sort((a, b) => a.name.localeCompare(b.name, 'en', { 'sensitivity': 'base' }));
          this.$set(this.listsByFieldValue, value, providers)
        } else if (value === 'pos_brand_id') {
          this.brandList = (await kvApi.keyValues.getList("POS_EQUIPMENT_BRAND", 100, 0)).data.sort((a, b) => a.display_order < b.display_order);
        } else if (["AD_GROUP", "OWNER", "DISTRIBUTION_CENTER"].includes(string)) {
          this.buildPartyList(string, value);
        } else if (["BILLING_PROGRAM_TYPE", "ADVERTISING_SERVICE", "HOSTING_FILE_OPTION", "LOYALTY_COUPON_PROGRAM"].includes(string)) {
          const items = (await kvApi.keyValues.getList(string, 100, 0)).data.sort((a, b) => a.display_order < b.display_order);
          items.push({'constant': "NOT_APPLICABLE", 'name': "Not Applicable", "id": "null"})
          this.$set(this.listsByFieldValue, value, items)
        } else if (['HOSTING_FILE_TYPE', 'HOSTING_FILE_PROGRAM'].includes(string)) {
          const items = (await kvApi.keyValues.getList(string, 100, 0)).data.sort((a, b) => a.display_order < b.display_order);
          this.$set(this.listsByFieldValue, value, items)
        } else if (['DAY_OF_WEEK'].includes(string)) {
          const items = (await kvApi.keyValues.getList(string, 100, 0)).data;
          this.$set(this.listsByFieldValue, value, items)
        } else if (value === 'scan_collection_program_id') {
          const programs = (await kvApi.keyValues.getList("SCAN_COLLECTION_PROGRAM", 100, 0)).data;
          this.$set(this.listsByFieldValue, value, programs)
        } else {
          const predefinedLists = {
            "AD_LENGTH": [7, 14],
            "SPONSORED_PROGRAMS": [
              { name: 'Adergy Program', id: 'ADERGY_PROGRAM' },
              { name: 'Alliance Link', id: 'ALLIANCE_LINK' },
              { name: 'eGrowcery', id: "EGROWCERY" },
              { name: 'Neptune Program', id: 'NEPTUNE_PROGRAM' },
            ]
          };
          if (predefinedLists[string]) {
            this.$set(this.listsByFieldValue, value, predefinedLists[string])
          } else if (string) {
            const items = (await kvApi.keyValues.getList(string, 100, 0)).data.sort((a, b) => a.name.localeCompare(b.name, 'en', { 'sensitivity': 'base' }));
            this.$set(this.listsByFieldValue, value, items)
          }
        }
      } catch (err) {
        this.handleError(err)
      }
    }
  }
}
</script>